/* eslint-disable sonarjs/no-duplicate-string */
import React from 'react';
import { PLAYERS_ID } from '../../../../constants';
import { checkTBSetPoint } from '../../../../utils/common';

// eslint-disable-next-line complexity
const TennisTieBreakHistoryRow = ({ history, hasWinningPlayer}) => {
  const isSetPoint = checkTBSetPoint(history?.playerOneScore, history?.playerTwoScore);
  return (
    <div
      className="tennisDetails__tieBreakRow"
    >
      <div className="tennisDetails__info">
        <div className="tennisDetails__info-serve text-right">
          {(history?.servingPlayer === PLAYERS_ID.PLAYER_1 && history?.lostServe) && (<div className="tennisDetails__label tennisDetails__label--serve">Lost serve</div>)}
          {isSetPoint && isSetPoint === PLAYERS_ID.PLAYER_1
            && hasWinningPlayer
            && (<span className="tennisDetails__label tennisDetails__label--matchPoint">mp</span>)}

          {isSetPoint && isSetPoint === PLAYERS_ID.PLAYER_1
            && !hasWinningPlayer
            && (<span className="tennisDetails__label tennisDetails__label--setPoint">sp</span>)}
        </div>

        <div className="tennisDetails__info-icon">
          {history?.servingPlayer === PLAYERS_ID.PLAYER_1 && (<i className="icon-tennis-ball" />)}
        </div>

        <div className="tennisDetails__info-score">
          <span className={`${history?.winningPlayer === PLAYERS_ID.PLAYER_1 ? 'clr-primary' : ''}`}>
            {history?.playerOneScore}
          </span>
          {' '}
          <span>-</span>
          {' '}
          <span className={`${history?.winningPlayer === PLAYERS_ID.PLAYER_2 ? 'clr-primary' : ''}`}>
            {history?.playerTwoScore}
          </span>
        </div>

        <div className="tennisDetails__info-icon">
          {history?.servingPlayer === PLAYERS_ID.PLAYER_2 && (<i className="icon-tennis-ball" />)}
        </div>

        <div className="tennisDetails__info-serve text-left">
          {isSetPoint && isSetPoint === PLAYERS_ID.PLAYER_2
            && hasWinningPlayer
            && (<span className="tennisDetails__label tennisDetails__label--matchPoint">mp</span>)}

          {isSetPoint && isSetPoint === PLAYERS_ID.PLAYER_2
            && !hasWinningPlayer
            && (<span className="tennisDetails__label tennisDetails__label--setPoint">sp</span>)}
          {(history?.servingPlayer === PLAYERS_ID.PLAYER_2 && history?.lostServe) && (<div className="tennisDetails__label tennisDetails__label--serve">Lost serve</div>)}
        </div>
      </div>
    </div>
  );
};
export default TennisTieBreakHistoryRow;
